import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { IconName, ButtonVariant, PopoverPosition, DropdownOptionGroup, ButtonSize, ButtonType, DropdownSelectionType, DropdownOptionDefault, DropdownOptionType, DropdownOption } from '@yupma/ui-kit';
import { EntityType, PhoneLabel, PhoneValue } from 'server-model';
import { CRMFieldDataService, IAMService } from 'src/app/services/services.module';

interface DisplayPhoneValue extends PhoneValue {
  isUnique: boolean;
  isDropdownOpen: boolean;
}

@Component({
  selector: 'app-phone-edit-popover',
  templateUrl: './phone-edit-popover.component.html',
  styleUrl: './phone-edit-popover.component.scss'
})
export class PhoneEditPopoverComponent {
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() value: PhoneValue[] = [];
  @Input() required: boolean = false;
  @Input() hideOptional: boolean = true;
  @Input() error: boolean = false;
  @Input() inlineInfo: string = '';
  @Input() errorText: string = 'This field is required.';
  @Output() updatePhones = new EventEmitter<PhoneValue[]>()
  @Output() close = new EventEmitter()

  displayPhoneValue: DisplayPhoneValue[] = [];
  iconNames = IconName;
  buttonVariants = ButtonVariant;
  popoverPositions = PopoverPosition;
  labelDropdownOptions: DropdownOptionGroup[] = [];
  buttonSizes = ButtonSize;
  buttonTypes = ButtonType;
  dropdownSelectionTypes = DropdownSelectionType;

  constructor(
    private iamService: IAMService,
    private crmFieldDataService: CRMFieldDataService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (!!(changes['value'])) {
      this.createDispalyPhoneValue()
    }
  }


  ngOnInit() {
    this.createDispalyPhoneValue()
  }


  private createDispalyPhoneValue() {
    this.createLabelDropdown()
    if (this.value && this.value.length) {
      this.displayPhoneValue = this.value.map((phone) => ({
        ...phone,
        isUnique: true,
        isDropdownOpen: false,
      }));
    } else {
      this.displayPhoneValue = [{ label: PhoneLabel.WORK, value: "", primary: true, isUnique: true, isDropdownOpen: false, }]
    }
  }

  private createLabelDropdown() {
    let work = new DropdownOptionDefault(DropdownOptionType.DEFAULT, PhoneLabel.WORK, PhoneLabel.WORK);
    let personal = new DropdownOptionDefault(DropdownOptionType.DEFAULT, PhoneLabel.PERSONAL, PhoneLabel.PERSONAL);
    let other = new DropdownOptionDefault(DropdownOptionType.DEFAULT, PhoneLabel.OTHER, PhoneLabel.OTHER);
    let labelGroup = new DropdownOptionGroup('', [work, personal, other]);
    this.labelDropdownOptions = [labelGroup];
  }

  toggleLabelDropdown(index: number, state: boolean) {
    this.displayPhoneValue[index].isDropdownOpen = state;
    if (state === true) {
      this.labelDropdownOptions[0].options.forEach((option) => {
        option.selected = option.label === this.displayPhoneValue[index].label;
      });
    }
  }

  updateLabel(index: number, newLabel: DropdownOption) {
    this.displayPhoneValue[index].label = newLabel.value as PhoneLabel;
  }

  updateValue(index: number, newValue: string, phone: DisplayPhoneValue) {
    this.displayPhoneValue[index].value = newValue;
    this.checkUniqueValue(newValue, phone);
  }

  removePhone(index: number) {
    this.displayPhoneValue.splice(index, 1);

    if (this.displayPhoneValue.length > 0) {
      this.displayPhoneValue[0].primary = true;
    }
  }

  addPhone() {
    this.displayPhoneValue.push({
      label: PhoneLabel.WORK,
      value: '',
      primary: false,
      isUnique: true,
      isDropdownOpen: false,
    });
  }

  // submitPhones() {
  //   const phoneValues: PhoneValue[] = this.displayPhoneValue
  //     .filter(phone => phone.value.trim() !== '') // Exclude entries with empty 'value'
  //     .map(({ isDropdownOpen, ...phoneValue }) => phoneValue);

  //   this.updatePhones.emit(phoneValues);
  //   this.close.emit();
  // }

  submitPhones() {
    const emailValues: PhoneValue[] = [];

    const uniqueEmails = new Map<string, PhoneValue>();

    // Filter and consolidate email values
    this.displayPhoneValue.forEach(phone => {
      const trimmedValue = phone.value.trim();
      if (trimmedValue !== '') {
        if (!uniqueEmails.has(trimmedValue)) {
          uniqueEmails.set(trimmedValue, {
            label: phone.label,
            value: trimmedValue,
            primary: phone.primary,
          });
        }
      }
    });

    // Check if all isUnique are true
    const allUnique = this.displayPhoneValue.every(phone => phone.isUnique);

    if (allUnique) {
      emailValues.push(...uniqueEmails.values());
      this.updatePhones.emit(emailValues);
      this.close.emit();
    }
  }

  closePopover() {
    this.close.emit();
  }

  async checkUniqueValue(value: any, field: DisplayPhoneValue) {
    try {
      const organisationId = this.iamService.getOrganisationId();
      let isUnique = [];
      isUnique = (await this.crmFieldDataService.validateField(organisationId, EntityType.CONTACT, [{ name: this.name, value: value }])).data;
      if (isUnique.length) {
        field.isUnique = false;
      } else {
        field.isUnique = true;
      }
    } catch (error) {
      console.log(error)
    }
  }
}
